/* eslint-disable max-len */
/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { Formik, Form } from 'formik';

import useToast from '../../../hooks/useToast';
import HeaderTable from '../../WorkReports/ViewOptionsContainer/DailyView/LineTableContainer/HeaderTable';
import SendToApproveAllMonthlyLines from '../MonthlyActionsButtons/MonthlyWorkReportActionButtons/SendToApproveAllMonthlyLines';
import {
  getColorQuantityNotifiedCalendar,
  getMonthlyLinesByLocation
} from '../../../services/monthlyServiceRequest';
import LineRowContainerGeneric from '../../WorkReports/LineRowContainerGeneric/LineRowContainerGeneric';
import LoaderContext from '../../../context/LoaderProvider';
import InputCalendar from '../../Calendar/InputCalendar/InputCalendar';
import {
  formatFullDate,
  formatsEnum,
  getFirstDayOfMonth,
  getLastDateOfMonth,
  MONTHS
} from '../../../utils/formatUtils';
import { useWorkReportModals } from '../../../context/WorkReportModalsContext';
import { workReportLineStatus } from '../../../utils/dataStatus';
import NoWorkReports from '../../WorkReports/NoWorkReports';
import { AttachedFilesPermissions, PositionLinePermissions } from '../RequestDetailTypes';
import { checkRol } from '../../../security';
import { notificador, proveedorNotificador } from '../../../security/constantsRols';
import ComponentWithTooltip from '../../ComponentWithTooltip/ComponentWithTooltip';
import colors from '../../../styles/colors.module.scss';
import { useFilterContext } from '../../../context/FilterDetailSDSContext';
import { useDetailServiceRequest } from '../../../context/DetailServiceRequestProvider';

import NoMonthlyLines from './NoMonthlyLines';

const initialValues = {};

const MonthlyUbicationLinesContainer = (props) => {
  const {
    accordionData,
    hasPermissionsToAddLines,
    hasPositionLines,
    month,
    newLineAdded,
    positionLinePermissions,
    setAccordionsSelecteds,
    setShowAddPLToUbicationModal,
    setRefreshFetch,
    showContentAccordion,
    year,
    asignationType,
    disabledEditStateCancelOrFinish,
    isTemplate,
    ubicationIndex,
    handleUpdateLocationData,
    filesPermissions,
    search,
    isOyM,
    notificaPP,
    refreshFetch
  } = props;
  const queryParams = new URLSearchParams(search);
  const [fecha] = useState(
    queryParams.get('fecha')
      ? formatFullDate(queryParams.get('fecha'), formatsEnum.FORMAT_DATE_2)
      : null
  );

  const firstDayOfSSM = getFirstDayOfMonth(MONTHS.indexOf(month), year);
  const lastDayOfSSM = getLastDateOfMonth(MONTHS.indexOf(month), year);

  const firstDayMonth = new Date(firstDayOfSSM);

  firstDayMonth.setDate(firstDayMonth.getDate() + 1);
  const lastDay = new Date(lastDayOfSSM);

  lastDay.setDate(lastDay.getDate() + 1);
  const today = new Date();

  // If today it`s between firstDayOfSSM and lastDayOfSSM
  // pick today, else pick LastDayOfSSm
  const intialDay =
    today < lastDay && today > firstDayMonth ? today.toISOString().split('T')[0] : lastDayOfSSM;

  const [firstDayWithLine, setFirstDayWithLine] = useState();
  const [lastDayWithLine, setLastDayWithLine] = useState();
  const [lines, setLines] = useState([]);
  const [linesToApprove, setLinesToApprove] = useState([]);
  const [changeInLines, setChangeInLines] = useState(false);
  const [newFetch, setNewFetch] = useState(false);
  const [selectedDate, setSelectedDate] = useState(intialDay);
  const [daysWithLines, setDaysWithLines] = useState([]);
  const [isNotificationWindowOpen, setIsNotificationWindowOpen] = useState(null);
  const [forceWindow, setForceWindow] = useState(null);
  const form = useRef();
  const { id: idMSDS } = useParams();
  const { setNewToast } = useToast();
  const { setLoader } = useContext(LoaderContext);
  const { setSelectedDate: setModalsContextDate } = useWorkReportModals();
  const { id: serviceRequestId } = useParams();
  // When this component uses templates, it is not wrapped in a filter provider, so there is no context and it cannot destructure filter.
  const filterContext = useFilterContext();

  const { details } = useDetailServiceRequest();

  const getNotificationWindowState = async () => {
    if (isTemplate) return;
    try {
      const { forzarVentanaNotificacion } = details;

      setForceWindow(forzarVentanaNotificacion);
    } catch (error) {
      setNewToast({
        type: 'ERROR',
        message: error.message
      });
    }
  };

  useEffect(() => {
    if (details && serviceRequestId) {
      getNotificationWindowState();
    }
  }, [serviceRequestId, details]);

  const hasNoLinesForThisDay = hasPositionLines && !isTemplate && lines?.length === 0;

  const hasNoLines =
    !hasPositionLines || (!!lines?.length && lines?.every((line) => line.eliminarPosicionLinea));

  const linesMapper = (linesToMap) =>
    linesToMap?.map((line) => ({
      ...line,
      positionName: `${line.numeroPosicion} - ${line.descripcionPosicionSap}`,
      lineName: `${line.numeroLinea} - ${line.descripcionLineaSap}`,
      cantidad: line?.cantidad || null,
      disabled:
        !(
          line.estadoEnum === workReportLineStatus.pendiente ||
          line.estadoEnum === workReportLineStatus.devolver
        ) ||
        // It's understood that if they don't have permission to send or rectify
        // then they DO NOT have permission to edit the input
        !positionLinePermissions.sendToApprove ||
        !positionLinePermissions.rectifyLine
    }));

  const colorCalendarMapper = (objectCalendar) => {
    const { fechasConCantidadesNotificadas, fechasConCantidadesNotificadasDevueltas } =
      objectCalendar;

    const datesWithQuantityNotified = fechasConCantidadesNotificadas
      ?.map((date) => ({ color: '#312b2bc7', date }))
      ?.concat(
        fechasConCantidadesNotificadasDevueltas?.map((date) => ({ color: '#FF0000', date }))
      );

    return datesWithQuantityNotified;
  };

  useEffect(() => {
    if (fecha) setSelectedDate(formatFullDate(fecha, formatsEnum.FORMAT_DATE_2));
  }, [fecha]);

  const getLines = async (date) => {
    if (showContentAccordion) {
      setLoader(true);
      try {
        const body = {
          fecha: date,
          forzarVentanaNotificacion: forceWindow,
          posicionesLineas: filterContext?.filter?.posicionesLineas?.map((pos) => ({
            posicionId: pos?.posicionId,
            lineaId: pos?.lineaId,
            posicion: pos?.posicion,
            linea: pos?.linea
          }))
        };

        const response = await getMonthlyLinesByLocation(idMSDS, accordionData?.id, body);
        const mappedLines = linesMapper(response?.lineas);

        const responseCalendar = await getColorQuantityNotifiedCalendar({
          id: accordionData?.id,
          date
        });

        const fechasFlujoMobile = responseCalendar?.fechasFlujoMobile || [];
        const dateIso = new Date(date).toISOString().split('.')[0]; // '2025-08-31T00:00:00'

        const adapterLines = mappedLines.map((line) => ({
          ...line,
          flujoMobile: fechasFlujoMobile.includes(dateIso) || responseCalendar?.flujoMobile
        }));
        const mapperCalendarColor = colorCalendarMapper(responseCalendar);

        setIsNotificationWindowOpen(response?.ventanaActiva);
        setDaysWithLines(mapperCalendarColor);
        setSelectedDate(date);
        setLines(adapterLines);
        setLoader(false);
        setFirstDayWithLine(response?.primerFecha);
        setLastDayWithLine(response?.ultimaFecha);
      } catch (error) {
        setLoader(false);
        setNewToast({
          type: 'ERROR',
          message: error.message
        });
      }
    }
  };

  const handleChangeDate = (value) => {
    const dateToFetch = formatFullDate(value, formatsEnum.FORMAT_DATE_2);
    const dateSelected = formatFullDate(selectedDate, formatsEnum.FORMAT_DATE_2);

    // If the date did not change, do not fetch
    if (dateSelected !== dateToFetch) getLines(dateToFetch);
  };

  const handleGoFirstLastDay = (firstDay = false) => {
    if (firstDay) {
      getLines(firstDayWithLine);
    } else {
      getLines(lastDayWithLine);
    }
  };

  useEffect(() => {
    if (!isTemplate && showContentAccordion) {
      getLines(selectedDate);
    }
  }, [showContentAccordion, newLineAdded, refreshFetch]);

  useEffect(() => {
    if (selectedDate) getLines(selectedDate);
  }, [newFetch, newLineAdded]);

  useEffect(() => {
    setLinesToApprove(lines);
    form?.current?.setValues({
      line: lines
    });
  }, [lines]);

  useEffect(() => {
    setLinesToApprove(form?.current?.values?.line);
  }, [changeInLines]);

  useEffect(() => {
    setModalsContextDate(selectedDate);
  }, [selectedDate]);

  const isProviderOrNotifier = checkRol(proveedorNotificador) || checkRol(notificador);

  const handleDeleteTemplateLine = (index) => {
    handleUpdateLocationData({
      index: ubicationIndex,
      lineNumber: lines[index].numeroLinea,
      positionNumber: lines[index].numeroPosicion,
      plIndex: index
    });
    setLines(lines);
  };

  useEffect(() => {
    if (isTemplate && showContentAccordion) {
      setLines(accordionData.posLines);
      form?.current?.setValues({
        line: accordionData.posLines
      });
    }
  }, [accordionData.posLines, showContentAccordion, isTemplate]);

  const CalendarComponent = () => (
    <InputCalendar
      arrayDate={daysWithLines}
      colorCalendar={
        isNotificationWindowOpen ? colors.calendarOpenWindow : colors.calendarClosedWindow
      }
      handleChangeDate={(date) => handleChangeDate(date)}
      isMSDS
      maxDate={lastDayOfSSM}
      minDate={firstDayOfSSM}
      onClickFirstDay={() => handleGoFirstLastDay(true)}
      onClickLastDay={() => handleGoFirstLastDay()}
      selectDay={selectedDate}
      showNotification={!isOyM && isProviderOrNotifier}
    />
  );

  return (
    <>
      {hasPositionLines && !isTemplate ? (
        <div className="d-flex justify-content-end mt-4">
          {!isOyM && !isNotificationWindowOpen ? (
            <ComponentWithTooltip tooltipText="Fecha fuera de la ventana de notificación">
              {CalendarComponent()}
            </ComponentWithTooltip>
          ) : (
            CalendarComponent()
          )}
        </div>
      ) : null}

      {hasPositionLines &&
      !(lines?.length && lines.every((line) => line?.eliminarPosicionLinea)) ? (
        <>
          <ul className="list_container">
            <HeaderTable tableTemplate={isTemplate} />
            <Formik initialValues={initialValues} innerRef={form}>
              {({ values }) => (
                <Form>
                  {values?.line?.map((line, index) =>
                    line?.eliminarPosicionLinea ? null : (
                      <>
                        <li className="general_row_container" key={line.idParteDiario}>
                          <LineRowContainerGeneric
                            asignationType={asignationType}
                            changeInLines={changeInLines}
                            deleteTemplateLines={handleDeleteTemplateLine}
                            disabledEditStateCancelOrFinish={disabledEditStateCancelOrFinish}
                            disabledInput={accordionData?.finalizada}
                            enableNotification={line.habilitaNotificacion}
                            filesPermissions={filesPermissions}
                            forceWindow={forceWindow}
                            idLocation={accordionData?.id}
                            indexLine={index}
                            isNotificationWindowOpen={isNotificationWindowOpen}
                            isOyM={isOyM}
                            line={{
                              ...line,
                              locationId: accordionData?.id
                            }}
                            maxDate={lastDayOfSSM}
                            minDate={firstDayOfSSM}
                            monthly
                            newFetch={newFetch}
                            notificaPP={notificaPP}
                            positionLinesPermissions={positionLinePermissions}
                            selectedDate={selectedDate}
                            setChangeInLines={setChangeInLines}
                            setNewFetch={setNewFetch}
                            setRefreshFetch={setRefreshFetch}
                            setWorkReportLines={setLines}
                            templateComponent={isTemplate}
                            typeOfUbication={{ id: accordionData?.tipoUbicacionEnum }}
                          />
                        </li>
                      </>
                    )
                  )}
                </Form>
              )}
            </Formik>
          </ul>
          <hr />
          {!isTemplate && (
            <SendToApproveAllMonthlyLines
              hasSendToApprovePermissions={positionLinePermissions.sendToApprove}
              newFetch={newFetch}
              selectedDate={selectedDate}
              setNewFetch={setNewFetch}
              workReportId={idMSDS}
              workReportLines={linesToApprove || []}
            />
          )}
        </>
      ) : null}

      {hasNoLinesForThisDay && (
        // This means there are no lines on the selected date
        <NoWorkReports subtitle=" " title="No hay líneas para la fecha seleccionada" />
      )}

      {hasNoLines && (
        // If it has no assigned lines on any date
        <NoMonthlyLines
          buttonLabel="Agregar líneas"
          hasPermissionsToAddLines={hasPermissionsToAddLines && !disabledEditStateCancelOrFinish}
          id={accordionData?.id}
          setAccordionsSelecteds={setAccordionsSelecteds}
          setShowAddPLToUbicationModal={setShowAddPLToUbicationModal}
          title="Esta ubicación no tiene líneas cargadas"
        />
      )}
    </>
  );
};

MonthlyUbicationLinesContainer.propTypes = {
  accordionData: PropTypes.shape({
    nombre: PropTypes.string,
    id: PropTypes.number,
    tipoUbicacionEnum: PropTypes.number,
    finalizada: PropTypes.bool,
    posLines: PropTypes.arrayOf(
      PropTypes.shape({
        numeroLinea: PropTypes.number,
        numeroPosicion: PropTypes.number,
        descripcionLineaSap: PropTypes.string,
        descripcionLineaYClic: PropTypes.string,
        unidadMedida: PropTypes.number,
        descripcionPosicionSap: PropTypes.string,
        descripcionPosicionYClic: PropTypes.string,
        onCall: PropTypes.bool,
        mensualizada: PropTypes.bool
      })
    )
  }).isRequired,
  hasPermissionsToAddLines: PropTypes.bool.isRequired,
  hasPositionLines: PropTypes.bool.isRequired,
  month: PropTypes.string.isRequired,
  newLineAdded: PropTypes.bool.isRequired,
  setAccordionsSelecteds: PropTypes.func,
  setShowAddPLToUbicationModal: PropTypes.func.isRequired,
  setRefreshFetch: PropTypes.func.isRequired,
  showContentAccordion: PropTypes.bool.isRequired,
  positionLinePermissions: PositionLinePermissions.isRequired,
  year: PropTypes.string.isRequired,
  asignationType: PropTypes.number.isRequired,
  disabledEditStateCancelOrFinish: PropTypes.bool.isRequired,
  isTemplate: PropTypes.bool,
  ubicationIndex: PropTypes.number,
  handleUpdateLocationData: PropTypes.func,
  filesPermissions: AttachedFilesPermissions,
  search: PropTypes.string,
  isOyM: PropTypes.bool,
  notificaPP: PropTypes.bool.isRequired,
  refreshFetch: PropTypes.bool
};

MonthlyUbicationLinesContainer.defaultProps = {
  setAccordionsSelecteds: () => {
    /* empty */
  },
  isTemplate: false,
  ubicationIndex: 0,
  handleUpdateLocationData: () => {},
  filesPermissions: {
    visualize: false,
    write: false
  },
  search: '',
  isOyM: false,
  refreshFetch: false
};

export default MonthlyUbicationLinesContainer;
